import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StateShape as ReduxStateShape } from '../../../reducers';
import { actionCreators, emptySecondLeftSidebarOpt } from '../../../reducers/adminUI';
import { PageNavOption, pageNavOptions } from './NavOptions';
import MainLeftSideBar from './MainLeftSideBar';
import SecondLeftSidebar from './SecondLeftSidebar';

interface PropsShape {
    setLeftSidebarWidth?: (width: number) => void;
}

const LeftSideBar = (props: PropsShape) => {
    const dispatch = useDispatch();
    const { editor, pageNavSelectedOpt } = useSelector((state: ReduxStateShape) => ({
        ...state.templateEditor,
        ...state.adminUI,
    }));

    const [isSecondSidebarClosed, setIsSecondSidebarClosed] = useState(false);

    const handleOnClickPageOption = (opt: PageNavOption) => {
        if (opt.name === pageNavSelectedOpt?.name) {
            dispatch(actionCreators.setPageNavOpt(emptySecondLeftSidebarOpt));
        } else {
            dispatch(actionCreators.setPageNavOpt(opt));
        }
    };

    useEffect(() => {
        dispatch(actionCreators.setPageNavOpt(pageNavOptions[0]));
    }, []);

    return (
        <div className={'left-side-bars'}>
            <div className={'drawer'}>
                {editor && (
                    <div className={'main-left-side-bar'}>
                        <MainLeftSideBar
                            seletedPageOption={pageNavSelectedOpt || pageNavOptions[0]}
                            onClickPageOption={handleOnClickPageOption}
                            isSecondSidebarClosed={isSecondSidebarClosed}
                            setIsSecondSidebarClosed={setIsSecondSidebarClosed}
                        />
                    </div>
                )}
                {editor &&
                    pageNavSelectedOpt &&
                    (pageNavSelectedOpt.showOnSecondLeftSidebar ? (
                        <SecondLeftSidebar
                            component={pageNavSelectedOpt.component}
                            setLeftSidebarWidth={props.setLeftSidebarWidth}
                            isClosed={isSecondSidebarClosed}
                            setIsClosed={setIsSecondSidebarClosed}
                        />
                    ) : (
                        <>{pageNavSelectedOpt.component}</>
                    ))}
            </div>
        </div>
    );
};

export default LeftSideBar;
